import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { MenuResponseModel } from 'src/app/core/model/api-suc';
import { Card, MenuModel, Section } from 'src/app/core/model/menu.model';
import { MenuService } from 'src/app/core/service/menu.service';
import { SeguridadService } from 'src/app/core/service/seguridad/seguridad.service';
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css'],
  standalone: false
})
export class InicioComponent {
  public menuItems: MenuResponseModel;
  tipoRolUsuario = "";
  public lstMenu: MenuModel[];
  public lstSubMenu: any[];
  public sections2: Section[];
  public tituloMenuPadre: string = "";
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public menuService: MenuService,
    private seguridadService: SeguridadService,
    private router: Router,
    private route: ActivatedRoute) {
    this.matIconRegistry.addSvgIcon("Pattern.svg", this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../assets/icons/Pattern.svg"));
    this.tipoRolUsuario = seguridadService.getUsuarioRol;
    this.menuItems = menuService.getMenuSistema();
    this.lstMenu = this.menuItems.lstMenu;
    this.lstSubMenu = this.menuItems.lstSubMenu;
    this.lstSubMenu = this.agregarTieneHijos(this.lstSubMenu);
    this.sections2 = [];
  }

  ngOnInit() {
    let cards: any[];
    // Reiniciamos las secciones para llenarlas con el nuevo filtro
    this.route.queryParams.subscribe(params => {
      
      this.tituloMenuPadre = params['tituloMenuPadre'];
      this.sections2 = [];

      // Filtrar lstMenu para obtener solo aquellos que coincidan con el títuloMenuPadre
      this.lstMenu.filter(m => m.nombre == this.tituloMenuPadre).forEach(menu => {
        cards = this.lstSubMenu.filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
          .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
        let section = new Section(menu.id.toString(), menu.descripcion, cards);
        if (cards.length != 0) {
          this.sections2.push(section);
        }else{
          const listaSubMenuPadre = this.lstSubMenu.filter(subMenu => menu.id == subMenu.idMenuPadre);
          
          listaSubMenuPadre.forEach(menu => {
                                              cards = this.lstSubMenu
                                                      .filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
                                                      .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
                                              let section = new Section(menu.id.toString(), menu.descripcion, cards);
                                              if (cards.length != 0) {                               
                                                this.sections2.push(section);
                                              }
                            });
        }
      });

      // Filtrar lstSubMenu para obtener solo aquellos que coincidan con el títuloMenuPadre (Para submenus que son padres)
      this.lstSubMenu.filter(m => m.descripcion == this.tituloMenuPadre).forEach(menu => {
        cards = this.lstSubMenu.filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
          .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
        let section = new Section(menu.id.toString(), menu.descripcion, cards);
        if (cards.length != 0) {
          this.sections2.push(section);
        }else{
          const listaSubMenuPadre = this.lstSubMenu.filter(subMenu => menu.id == subMenu.idMenuPadre);
          
          listaSubMenuPadre.forEach(menu => {
                                              cards = this.lstSubMenu
                                                      .filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
                                                      .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
                                              let section = new Section(menu.id.toString(), menu.descripcion, cards);
                                              if (cards.length != 0) {                               
                                                this.sections2.push(section);
                                              }
                            });
        }
      });

      if (this.tituloMenuPadre == null || this.tituloMenuPadre == undefined || this.tituloMenuPadre === "") {
        this.sections2 = [];
        this.lstMenu.forEach(menu => {
          cards = this.lstSubMenu.filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
                                 .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
               
          let section = new Section(menu.id.toString(), menu.descripcion, cards);
          if (cards.length != 0) {
            this.sections2.push(section);
          }else{
            this.lstSubMenu.filter(subMenu => menu.id == subMenu.idMenuPadre)
                           .forEach(menu => {
                              
                              cards = this.lstSubMenu
                                      .filter(subMenu => subMenu.idMenuPadre === menu.id && subMenu.tieneHijos === false)
                                      .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
                              let section = new Section(menu.id.toString(), menu.descripcion, cards);
                              if (cards.length != 0) {                               
                                this.sections2.push(section);
                              }
                            });
          }

        });
        
      }
    });
    this.router.navigate(['/home/inicio']);

  }

  redirectTo(routerLink: string): void {
    let resolvedLink = "../../" + routerLink;
    this.router.navigate([resolvedLink]);
  }
  GoHome() {
    let cards: any[];
    this.sections2 = [];
    /*this.lstMenu.forEach(menu => {
      cards = this.lstSubMenu.filter(subMenu => subMenu.idMenuPadre === menu.id)
        .map(subMenu => new Card(subMenu.nombre, subMenu.descripcion, subMenu.url));
      let section = new Section(menu.id.toString(), menu.descripcion, cards);
      this.sections2.push(section);
    });*/
  }

  agregarTieneHijos(menuItems) {
    // Creamos un objeto para almacenar los ids de los elementos padres
    const padres = {};

    // Iteramos sobre el arreglo para identificar los elementos padres
    menuItems.forEach(item => {
      return item.tieneHijos = false;
    });

    // Iteramos nuevamente para agregar el valor "tieneHijos" a los elementos
    menuItems.forEach(item => {
      // @ts-ignore
      menuItems.forEach(item2 => {
        if (item.id == item2.idMenuPadre) {
          return item.tieneHijos = true;
        }
      })
    });

    return menuItems;
  }

}